import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function IndeterminateIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path d="M1 7V5H11V7H1Z" fill="currentColor" />
    </svg>
  );
}
